import { Link } from "react-router-dom";
import {
  Calculator,
  Users,
  Receipt,
  FileText,
  ClipboardList,
  Building2,
  UserCheck,
  Shield,
  ArrowRight,
} from "lucide-react";
import { SectionHeader } from "@/components/ui/SectionHeader";

const links = [
  { icon: Calculator, title: "Monthly Bookkeeping", href: "/monthly-bookkeeping-services", desc: "Accurate books, kept up to date every month." },
  { icon: Users, title: "Payroll (EMP201, EMP501)", href: "/payroll-emp201-emp501", desc: "Monthly payroll and SARS payroll submissions." },
  { icon: Receipt, title: "UIF Declarations", href: "/uif-monthly-declarations", desc: "Monthly UIF submissions to the Department of Labour." },
  { icon: FileText, title: "Annual Financial Statements", href: "/annual-financial-statements", desc: "Professional AFS that meet SARS requirements." },
  { icon: ClipboardList, title: "Annual Tax Returns", href: "/annual-tax-returns", desc: "Income tax returns filed accurately and on time." },
  { icon: ClipboardList, title: "Provisional Tax", href: "/provisional-tax-returns", desc: "Two provisional tax submissions per year." },
  { icon: Building2, title: "CIPC Annual Returns", href: "/cipc-annual-returns", desc: "Stay in good standing with CIPC." },
  { icon: UserCheck, title: "Beneficial Ownership", href: "/beneficial-ownership-submission", desc: "CIPC beneficial ownership register submissions." },
  { icon: Shield, title: "Workmen's Compensation", href: "/workmens-compensation", desc: "Annual COIDA return submissions." },
];

export const ServicesLinks = () => {
  return (
    <section className="py-20 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <SectionHeader
          label="Our Services"
          title="Everything Your Business Needs"
          description="Bookkeeping, payroll, tax and CIPC compliance — handled by SAICA-registered professionals."
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {links.map((s) => (
            <Link
              key={s.href}
              to={s.href}
              className="group p-6 rounded-2xl border border-border bg-card hover:border-primary/30 hover:shadow-md transition-all"
              aria-label={`Explore ${s.title}`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-accent flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <s.icon className="w-5 h-5" />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground group-hover:text-primary transition-colors">
                  {s.title}
                </h3>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed mb-3">{s.desc}</p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary">
                Explore {s.title} <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
